import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen, Check, AlertTriangle } from 'lucide-react';

const KartaPobytuRequirements = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <BookOpen className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Karta Pobytu Requirements
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Essential requirements and eligibility criteria for obtaining your residence card
          </p>
        </div>

        <div className="space-y-8">
          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <Check className="h-6 w-6 text-primary" />
                <CardTitle>Basic Eligibility Requirements</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="list-disc pl-6 space-y-2">
                <li>Valid passport with at least 6 months validity</li>
                <li>Legal stay in Poland at the time of application</li>
                <li>Proof of purpose of stay (work, study, business, etc.)</li>
                <li>Sufficient financial means to support yourself</li>
                <li>Health insurance coverage</li>
                <li>Registered place of residence in Poland</li>
              </ul>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <AlertTriangle className="h-6 w-6 text-yellow-500" />
                <CardTitle>Important Considerations</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="list-disc pl-6 space-y-2">
                <li>Applications must be submitted in person at your local voivodeship office</li>
                <li>All documents must be translated into Polish by a sworn translator</li>
                <li>Processing times vary by voivodeship and type of permit</li>
                <li>Incomplete applications will be rejected</li>
                <li>You may need to provide additional documents based on your specific situation</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base/getting-started')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Getting Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default KartaPobytuRequirements; 